/**
 * Collection subcollection list section — markup-only; reserve for editor / future UX.
 * Subcollection rows are rendered from collection metafields in Liquid (list of metaobjects or collections).
 */
(function () {
  document.documentElement.classList.add('js-collection-subcollection-list');
})();
